jQuery(document).ready(function ($) {
  $(".full-schedule-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: true,
    autoplay: false,
    rows: 0,
    infinite: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  // Split-day Week A / Week B toggle (inside schedule cards only)
  $(document).on("click", ".schedule-split-toggle__btn", function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $btn = $(this);
    if ($btn.hasClass("is-active")) {
      return;
    }

    var $schedule = $btn.closest(".schedule");
    var panel = $btn.attr("data-schedule-panel");

    $schedule
      .find(".schedule-split-toggle__btn")
      .removeClass("is-active")
      .attr("aria-selected", "false");
    $btn.addClass("is-active").attr("aria-selected", "true");

    $schedule.find(".schedule-times[data-schedule-panel]").attr("hidden", true);
    $schedule
      .find('.schedule-times[data-schedule-panel="' + panel + '"]')
      .removeAttr("hidden");
  });
});
